// store/modules/m5ui.js

import axios from 'axios';
import config from '@/config';

const state = {
  machines: [],
  loading: false,
  error: null,
  config: null
};

const getters = {
  getAllMachines: function(state) {
    return state.machines;
  },
  isLoading: function(state) {
    return state.loading;
  },
  getError: function(state) {
    return state.error;
  },
  getConfig: function(state) {
    return state.config;
  }
};

const actions = {
  fetchMachinesData: function({ commit }) {
    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    return axios
      .post(`${config.server_url}/api/m5ui/sync-devices`)
      .then(function(res) {
        if (res.data.success) {
          var machineList = res.data.data || [];
          console.log('Machine List:', machineList);
          commit('SET_MACHINE_LIST', machineList);
          return res.data;
        } else {
          throw new Error(res.data.message || 'Failed to fetch machines');
        }
      })
      .catch(function(err) {
        console.error('fetchMachinesData failed:', err);
        var errorMessage =
          (err.response && err.response.data && err.response.data.message) || err.message;
        commit('SET_ERROR', errorMessage);
        throw err;
      })
      .finally(function() {
        commit('SET_LOADING', false);
      });
  },

  postReloadMachines: function({ commit, dispatch }, locations) {
    if (!locations || locations.length === 0) {
      return Promise.reject(new Error('No locations provided'));
    }

    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    return axios
      .post(`${config.server_url}/api/m5ui/reload-content`, { locations: locations })
      .then(function(res) {
        if (res.data.success) {
          return dispatch('fetchMachinesData').then(function() {
            return res.data;
          });
        } else {
          throw new Error(res.data.message || 'Failed to reload content');
        }
      })
      .catch(function(err) {
        console.error('postReloadMachines failed:', err);
        var errorMessage =
          (err.response && err.response.data && err.response.data.message) || err.message;
        commit('SET_ERROR', errorMessage);
        throw err;
      })
      .finally(function() {
        commit('SET_LOADING', false);
      });
  },

  deleteMachines: function({ commit, dispatch }, locations) {
    if (!locations || locations.length === 0) {
      return Promise.reject(new Error('No locations provided'));
    }

    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    return axios
      .delete(`${config.server_url}/api/m5ui/delete-devices`, { data: { locations: locations } })
      .then(function(res) {
        if (res.data.success) {
          return dispatch('fetchMachinesData').then(function() {
            return res.data;
          });
        } else {
          throw new Error(res.data.message || 'Failed to delete devices');
        }
      })
      .catch(function(err) {
        console.error('deleteMachines failed:', err);
        var errorMessage =
          (err.response && err.response.data && err.response.data.message) || err.message;
        commit('SET_ERROR', errorMessage);
        throw err;
      })
      .finally(function() {
        commit('SET_LOADING', false);
      });
  },

  getM5UIConfig: function({ commit }) {
    return axios
      .get(`${config.server_url}/api/m5ui/config`)
      .then(function(res) {
        if (res.data.success) {
          commit('SET_CONFIG', res.data.config);
          return res.data.config;
        } else {
          throw new Error(res.data.message || 'Failed to get config');
        }
      })
      .catch(function(err) {
        console.error('getM5UIConfig failed:', err);
        throw err;
      });
  }
};

const mutations = {
  SET_LOADING: function(state, isLoading) {
    state.loading = isLoading;
  },
  SET_MACHINE_LIST: function(state, machines) {
    state.machines = machines;
  },
  SET_ERROR: function(state, error) {
    state.error = error;
  },
  SET_CONFIG: function(state, config) {
    state.config = config;
  }
};

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/m5ui.js